import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import NewsTrainer1 from "../../assets/showcases/trainer/service1.jpg";
import NewsTrainer2 from "../../assets/showcases/trainer/service2.jpg";
import NewsBarber1 from "../../assets/showcases/barber/service1.jpg";
import NewsBarber2 from "../../assets/showcases/barber/service2.jpg";
import NewsSalon1 from "../../assets/showcases/salon/service1.jpeg";
import NewsSalon2 from "../../assets/showcases/salon/service2.jpeg";
import NewsEcommerce1 from "../../assets/showcases/ecommerce/product1.jpg";
import NewsEcommerce2 from "../../assets/showcases/ecommerce/product2.jpg";
import NewsRestaurant1 from "../../assets/showcases/restaurant/product5.JPG";
import NewsRestaurant2 from "../../assets/showcases/restaurant/product6.JPG";
import { CreatorContext } from "../../context/CreatorContext";
import { useSwipeable } from "react-swipeable";
import chroma from "chroma-js";

const ShowcaseNews = ({ sector, news, showPadding, showRoundedImage }) => {
	const { t } = useTranslation();
	const [content, setContent] = useState([]);
	const { creator } = useContext(CreatorContext);

	const [currentIndex, setCurrentIndex] = useState(0);

	const handlers = useSwipeable({
		onSwipedLeft: () => handleNext(),
		onSwipedRight: () => handlePrev(),
		preventScrollOnSwipe: true,
		trackMouse: true,
	});

	const handleNext = () => {
		if (content && content.categories) {
			setCurrentIndex(
				(prevIndex) => (prevIndex + 1) % content.categories.length
			);
		}
	};

	const handlePrev = () => {
		if (content && content.categories) {
			setCurrentIndex((prevIndex) =>
				prevIndex === 0 ? content.categories.length - 1 : prevIndex - 1
			);
		}
	};

	useEffect(() => {
		const loadContent = () => {
			switch (sector) {
				case "barber":
					return [
						{
							title: t("news.newsBarber1Title"),
							description: t("news.newsBarber1Description"),
							image: NewsBarber1,
						},
						{
							title: t("news.newsBarber2Title"),
							description: t("news.newsBarber2Description"),
							image: NewsBarber2,
						},
					];

				case "salon":
					return [
						{
							title: t("news.newsSalon1Title"),
							description: t("news.newsSalon1Description"),
							image: NewsSalon1,
						},
						{
							title: t("news.newsSalon2Title"),
							description: t("news.newsSalon2Description"),
							image: NewsSalon2,
						},
					];

				case "trainer":
					return [
						{
							title: t("news.newsTrainer1Title"),
							description: t("news.newsTrainer1Description"),
							image: NewsTrainer1,
						},
						{
							title: t("news.newsTrainer2Title"),
							description: t("news.newsTrainer2Description"),
							image: NewsTrainer2,
						},
					];

				case "ecommerce":
					return [
						{
							title: t("news.newsEcommerce1Title"),
							description: t("news.newsEcommerce1Description"),
							image: NewsEcommerce1,
						},
						{
							title: t("news.newsEcommerce2Title"),
							description: t("news.newsEcommerce2Description"),
							image: NewsEcommerce2,
						},
					];

				case "restaurant":
					return [
						{
							title: t("news.newsRestaurant1Title"),
							description: t("news.newsRestaurant1Description"),
							image: NewsRestaurant1,
						},
						{
							title: t("news.newsRestaurant2Title"),
							description: t("news.newsRestaurant2Description"),
							image: NewsRestaurant2,
						},
					];

				default:
					return [];
			}
		};

		setContent(loadContent());
	}, [sector, t]);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				padding: showPadding
					? news?.value === "news4"
						? 2
						: 1
					: news?.value === "news4"
					? 1
					: 0,
				paddingTop: 0,
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
			}}
		>
			{news &&
				news?.value === "news1" &&
				content.map((news, index) => (
					<Box
						key={index}
						sx={{
							display: "flex",
							flexDirection: "column",
							overflow: "hidden",
							marginBottom: 0.5,
							backgroundColor: creator.themeColor,
							color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
							marginTop: showPadding ? 1 : 0,
						}}
					>
						<img
							src={news.image}
							alt={news.title}
							style={{
								width: "100%",
								height: "auto",
								objectFit: "cover",
								borderRadius: showRoundedImage ? 12 : 0,
							}}
						/>
						<Box
							sx={{
								paddingLeft: showPadding ? 0 : 1,
								paddingRight: showPadding ? 0 : 1,
								marginTop: 1,
							}}
						>
							<Typography
								variant="h6"
								sx={{
									fontWeight: "bold",
									fontSize: "10px",
									textTransform: "inherit",
									color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
								}}
							>
								{news.title}
							</Typography>
							<Typography variant="body2" sx={{ fontSize: "8px" }}>
								{news.description}
							</Typography>
						</Box>
					</Box>
				))}
			{news &&
				news?.value === "news2" &&
				content.map((news, index) => (
					<Box
						key={index}
						sx={{
							display: "flex",
							flexDirection: "column",
							overflow: "hidden",
							marginBottom: 0.5,
							backgroundColor: creator.themeColor,
							color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
							marginTop: showPadding ? 1 : 0,
						}}
					>
						<img
							src={news.image}
							alt={news.title}
							style={{
								width: "100%",
								height: "80px",
								objectFit: "cover",
								borderRadius: showRoundedImage ? 12 : 0,
							}}
						/>
						<Box
							sx={{
								paddingLeft: showPadding ? 0 : 1,
								paddingRight: showPadding ? 0 : 1,
								marginTop: 1,
							}}
						>
							<Typography
								variant="h6"
								sx={{
									fontWeight: "bold",
									fontSize: "10px",
									textTransform: "inherit",
									color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
								}}
							>
								{news.title}
							</Typography>
							<Typography variant="body2" sx={{ fontSize: "8px" }}>
								{news.description}
							</Typography>
						</Box>
					</Box>
				))}
			{news && news?.value === "news3" && (
				<Grid container spacing={showPadding ? 1 : 0}>
					{content.map((news, index) => (
						<Grid item sm={6}>
							<Box
								key={index}
								sx={{
									display: "flex",
									flexDirection: "column",
									overflow: "hidden",
									marginBottom: 0.5,
									backgroundColor: creator.themeColor,
									color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
									marginTop: showPadding ? 1 : 0,
								}}
							>
								<img
									src={news.image}
									alt={news.title}
									style={{
										width: "100%",
										height: "65px",
										objectFit: "cover",
										borderRadius: showRoundedImage ? 12 : 0,
									}}
								/>
								<Box
									sx={{
										paddingLeft: showPadding ? 0 : 1,
										paddingRight: showPadding ? 0 : 1,
										marginTop: 1,
									}}
								>
									<Typography
										variant="h6"
										sx={{
											fontWeight: "bold",
											fontSize: "10px",
											textTransform: "inherit",
											color:
												creator.themeMode === "Dark" ? "#ffffff" : "#000000",
										}}
									>
										{news.title}
									</Typography>
									<Typography
										variant="body2"
										sx={{
											fontSize: "8px",
											overflow: "hidden",
											display: "-webkit-box",
											WebkitLineClamp: 3,
											WebkitBoxOrient: "vertical",
										}}
									>
										{news.description}
									</Typography>
								</Box>
							</Box>
						</Grid>
					))}
				</Grid>
			)}

			{news && news?.value === "news4" && (
				<Box sx={{ marginTop: showPadding ? 2 : 1 }}>
					{content.map((news, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								flexDirection: "column",
								overflow: "hidden",
								marginBottom: 0.5,
								backgroundColor: creator.themeColor,
								color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
							}}
						>
							<Typography
								variant="h6"
								sx={{
									fontWeight: "bold",
									fontSize: "8px",
									textTransform: "inherit",
									color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
								}}
							>
								{news.title}
							</Typography>
							<Divider
								sx={{
									marginTop: showPadding ? 2 : 1,
									marginBottom: showPadding ? 2 : 1,
									borderColor:
										creator.themeMode === "Dark"
											? chroma(creator.themeColor).brighten(1).hex()
											: chroma(creator.themeColor).darken(0.5).hex(),
								}}
							/>
						</Box>
					))}
				</Box>
			)}

			{news && news?.value === "news5" && (
				<Box sx={{ paddingTop: showPadding ? 1 : 0, flex: 1 }}>
					<img
						src={content[0].image}
						alt={content[0].title}
						style={{
							width: "100%",
							height: 220,
							objectFit: "cover",
							borderRadius: showRoundedImage ? 12 : 0,
						}}
					/>
					<Box
						sx={{
							paddingLeft: showPadding ? 0 : 1,
							paddingRight: showPadding ? 0 : 1,
							marginTop: 1,
						}}
					>
						<Typography
							variant="h6"
							sx={{
								fontWeight: "bold",
								fontSize: "10px",
								textTransform: "inherit",
								textAlign: "center",
								color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
							}}
						>
							{content[0].title}
						</Typography>
						<Typography
							variant="body2"
							sx={{
								fontSize: "8px",
								overflow: "hidden",
								display: "-webkit-box",
								WebkitLineClamp: 3,
								WebkitBoxOrient: "vertical",
								textAlign: "center",
							}}
						>
							{content[0].description}
						</Typography>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							gap: 1,
							marginBottom: 1,
							marginTop: 2,
						}}
					>
						<Box
							sx={{
								width: 4,
								height: 4,
								borderRadius: "50%",
								backgroundColor: creator.themeColor,
								color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
								marginBottom: 1,
							}}
						/>
						<Box
							sx={{
								width: 4,
								height: 4,
								borderRadius: "50%",
								backgroundColor: creator.themeColor,
								color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
								marginBottom: 1,
							}}
						/>
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseNews;
